module.exports = __webpack_public_path__ + "static/media/envelope.7853ceb3.svg";